<template>
  <rect x="2" y="3" width="11" height="1" fill="#A6A6A6" />
  <rect x="7" y="5" width="1" height="2" fill="#A6A6A6" />
  <rect x="7" y="8" width="1" height="2" fill="#A6A6A6" />
  <rect x="7" y="11" width="1" height="2" fill="#A6A6A6" />
</template>
